import { render } from "./MedNytt.vue?vue&type=template&id=42c64055"
import script from "./MedNytt.vue?vue&type=script&lang=js"
export * from "./MedNytt.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__